var _circle, _path;
var _excluded = ["title", "titleId", "desc", "descId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import * as React from "react";
var SvgPressMagnifyingGlass = function SvgPressMagnifyingGlass(_ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    desc = _ref.desc,
    descId = _ref.descId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 28,
    height: 28,
    fill: "none",
    viewBox: "0 0 28 28",
    role: "img",
    "aria-labelledby": titleId,
    "aria-describedby": descId
  }, props), desc ? /*#__PURE__*/React.createElement("desc", {
    id: descId
  }, desc) : null, title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 14,
    cy: 14,
    r: 14,
    fill: "#E73C58"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M12.763 17.886c.822 0 1.634-.167 2.382-.49l2.11 2.828c.198.265.53.41.872.38a.96.96 0 0 0 .784-.522.87.87 0 0 0-.086-.904l-2.09-2.8c1.3-1.175 1.945-2.856 1.744-4.545s-1.226-3.192-2.77-4.063a6.05 6.05 0 0 0-5.097-.378c-1.668.633-2.928 1.967-3.405 3.606-.478 1.638-.118 3.394.972 4.745 1.09 1.352 2.786 2.144 4.584 2.143m0-9.072c1.018 0 1.994.383 2.714 1.063a3.53 3.53 0 0 1 1.124 2.566c0 .962-.404 1.885-1.124 2.566a3.95 3.95 0 0 1-2.714 1.062 3.96 3.96 0 0 1-2.714-1.062 3.53 3.53 0 0 1-1.124-2.566 3.53 3.53 0 0 1 1.124-2.566 3.95 3.95 0 0 1 2.714-1.063"
  })));
};
export default SvgPressMagnifyingGlass;